interface ChartConstants {
  width: number
}

export const constants: ChartConstants = {
  /**
   * The viewbox width of the svg
   */
  width: 400,
}

export default constants
